import withReducer from '../../store/withReducer'
import PatientFile from './container'
import reducer from './module'

export default withReducer('patientFile', reducer)(PatientFile)



// WEBPACK FOOTER //
// ./src/legacy/pages/PatientFile/index.js